import React, { useState, useEffect } from "react";


const CountDownCard3 = ({ title = `Exclusive Test Pakage!`, discount = 50, endTime= "2026-12-31T23:59:59"}) => {
  const [timeLeft, setTimeLeft] = useState({ d: 0, h: 0, m: 0, s: 0 });

  const formatTime = () => {
    const total = Date.parse(endTime) - Date.now();

    if (total <= 0)
      return setTimeLeft({ d: 0, h: 0, m: 0, s: 0 });

    const d = Math.floor(total / (1000 * 60 * 60 * 24));
    const h = Math.floor((total / (1000 * 60 * 60)) % 24);
    const m = Math.floor((total / (1000 * 60)) % 60);
    const s = Math.floor((total / 1000) % 60);

    setTimeLeft({ d, h, m, s });
  };

  useEffect(() => {
    const timer = setInterval(formatTime, 1000);
    return () => clearInterval(timer);
  }, []);

  return (<>
    <div className="ct3-section">
      <div className="ct3-wrapper">

        {/* Product Left */}
        <div className="ct3-image">
          <img
            src="https://i.postimg.cc/NjF4BFVz/red_haired_lady_eyeglasses_holds_books_shows_ok_sign_1_removebg_preview.png"
            alt="Smart Device"
          />
        </div>
 {/* Content Right */}
        <div className="ct3-content">
          <span className="ct3-badge">Offer</span>

          <h2>{title}</h2>
          <h3 className="ct3-off-text"><span>{discount}%</span> Off</h3>

          {/* Countdown */}
          <div className="timer-box-ct3">
            {["Days", "Hrs", "Min", "Sec"].map((label, i) => {
              const value = [timeLeft.d, timeLeft.h, timeLeft.m, timeLeft.s][i];
              return (
                <div key={label} className="time-card-ct3">
                  <span className="time-value-ct3">{value}</span>
                  <span className="time-label-ct3">{label}</span>
                </div>
              );
            })}
          </div>

          <button className="ct3-btn">Enroll Now →</button>
        </div>
       
      </div>
    </div>
    <style>{`.ct3-section {
  width: 100%;
  background: linear-gradient(135deg, #000, #111);
  padding: 70px 0;
  display: flex;
  justify-content: center;
}

.ct3-wrapper {
  width: 90%;
  max-width: 1250px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
}

.ct3-image img {
  width: 340px;
  filter: drop-shadow(0px 10px 35px rgba(0, 207, 255, 0.3));
  transform: perspective(500px) translateZ(30px);
  transition: 0.4s ease;
}
.ct3-image img:hover {
  transform: perspective(500px) translateZ(50px) scale(1.05);
}

.ct3-content {
  flex: 1;background: rgba(144, 202, 249,0.1);padding:15px;
  color: #fff;border-radius: 10px;
}

.ct3-badge {
  display: inline-block;
  padding: 6px 14px;
  background: rgba(144, 202, 249,1);
  color: #000;
  font-weight: bold;
  border-radius: 4px;
  margin-bottom: 12px;
}

h2 {
  font-size: 34px;
  margin: 8px 0;
  font-weight: 700;
}

.ct3-off-text {
  font-size: 38px;
  font-weight: 900;
  color: #ffffff;
  margin-bottom: 24px;
}.ct3-off-text span {
  font-size: 48px;
  font-weight: 900;
  color: rgba(144, 202, 249,1);
  margin-bottom: 24px;
}

/* Countdown */
.timer-box-ct3 {
  display: flex;
  gap: 14px;
  margin-bottom: 30px;
}

.time-card-ct3 {
  width: 70px;
  height: 70px;
  background: rgba(144, 202, 249,1);
  border: 2px solid #001432; color: #001432;
  border-radius: 10px;
  text-align: center;
  padding-top: 10px;
  box-shadow: 0px 0px 12px rgba(0, 174, 255, 0.4);
}

.time-value-ct3 {
  font-size: 26px;
  font-weight: 800;
  display: block;
}

.time-label-ct3 {
  font-size: 12px;
  opacity: 0.7;
}

.ct3-btn {
  background: rgba(144, 202, 249,1);
  color: #001432;
  padding: 14px 28px;
  border-radius: 6px;
  border: none;
  font-size: 17px;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
}

.ct3-btn:hover {
  background: rgba(144, 202, 249,1);
  box-shadow: 0 0 12px rgba(0,255,255,0.4);
}

/* Mobile Responsive */
@media (max-width: 850px) {
  .ct3-wrapper {
    flex-direction: column;
    text-align: center;
  }

  .timer-box-ct3 {
    justify-content: center;
  }
}
`}</style>
    </>
  );
};

export default CountDownCard3;
